import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Altours",
    title: "Unveil Nature’s Hidden Wonders",
    content: "Journey into landscapes, where majestic cliffs and serene waterfalls invite you for an unforgettable escape into nature.",
    buttonText: "Explore Now",
    buttonLink: "Destinations",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Altours",
    title: "Indulge in Premium Camping Escapades",
    content: "Immerse yourself in tailor-made camping adventures, designed for those who seek tranquility under starlit skies.",
    buttonText: "Discover More",
    buttonLink: "About-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Altours",
    title: "Embark on Exquisite Trekking Journeys",
    content: "Traverse trails from forest walks to alpine hikes for authentic trekking experiences.",
    buttonText: "Start Your Journey",
    buttonLink: "Tours",
  },
];

export default home;